const isResourceDetailDocumentPDF = (resource) => {
  return resource.kind === "document" && resource.mimeType === "application/pdf";
};
const isResourceDetailDocumentWithGeneratedPDFPreview = (resource) => {
  return !!resource.mimeType && resource.kind === "document" && [
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.ms-powerpoint"
  ].includes(resource.mimeType);
};
const isResourceDetailDocumentText = (resource) => {
  return resource.kind === "document" && resource.mimeType === "text/plain";
};
const isResourceDetailDocumentCsv = (resource) => {
  return resource.kind === "document" && resource.mimeType === "text/csv";
};
const isResourceDetailDocumentMarkdown = (resource) => {
  return resource.kind === "document" && resource.mimeType === "text/markdown";
};
const isResourceDetailDocumentHTML = (resource) => {
  return resource.kind === "document" && resource.mimeType === "text/html";
};
const isResourceDetailDocumentJSON = (resource) => {
  return resource.kind === "document" && resource.mimeType === "application/json";
};
const isResourceDetailDocumentDOCX = (resource) => {
  return resource.kind === "document" && resource.mimeType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
};

export { isResourceDetailDocumentCsv, isResourceDetailDocumentDOCX, isResourceDetailDocumentHTML, isResourceDetailDocumentJSON, isResourceDetailDocumentMarkdown, isResourceDetailDocumentPDF, isResourceDetailDocumentText, isResourceDetailDocumentWithGeneratedPDFPreview };
//# sourceMappingURL=documentGuards.js.map
